import { GET_COMPANIES, SET_COMPANIES_LOADING, GET_COMPANIES_FAIL, CLEAR_STATE_COMAPANIES,
    REGISTER_COMPANY_SET_LOADING,REGISTER_COMPANY_SUCCESS, REGISTER_COMPANY_FAIL,
    GET__MY_COMPANY, SET_MY_COMPANY_LOADING, GET_MY_COMPANY_FAIL, CLEAR_STATE_MY_COMAPANY,
    POST_REQUEST_COMPANY, LOADING_REQUEST_COMPANY, REQUEST_COMPANY_FAIL,
    GET_ALL_REQUESTS, SET_ALL_REQUESTS_LOADING, GET_ALL_REQUESTS_FAIL, CLEAR_STATE_ALL_REQUESTS,
    POST_CANACEL_REQUEST, LOADING_CANACEL_REQUEST, CANACEL_REQUEST_FAIL,
    GET_COMPANY_REQUESTS, SET_COMPANY_REQUESTS_LOADING, GET_COMPANY_REQUESTS_FAIL, CLEAR_STATE_COMPANY_REQUESTS,
    POST_ACCEPT_REQUEST, LOADING_ACCEPT_REQUEST, POST_ACCEPT_FAIL,
    POST_REJECT_REQUEST, LOADING_REJECT_REQUEST, REJECT_REQUEST_FAIL } from '../actions/types'
import {CLEAR_EDIT_ERRORS, EDIT_COMPANY_FAIL, EDIT_COMPANY_SUCCESS, SET_EDIT_LOADING,
} from "../actions/actions";

const initialState = {
    companies: null,
    loadingCompanies: true,
    errorComapnies: null,
    loadingRegister:true,
    errorRegister:null,
    myCompany:null,
    loadingMy:true,
    errorMy:null,
    editError:null,
    loadingEdit: false,
    reqestResponse:null,
    loadingRequest:false,
    errorRequest:null,
    allRequests:null,
    loadingAllRequests:true,
    errorAllRequests:null,
    cancelResponse:null,
    loadingCancel:false,
    errorCancel:null,
    companyRequests:null,
    loadingCompanyRequests:true,
    errorCompanyRequests:null,
    acceptResponse:null,
    loadingAccept:false,
    errorAccept:null,
    rejectResponse:null,
    loadingReject:false,
    errorReject:null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANIES:
            return{
                ...state,
                companies: action.payload,
                loadingCompanies:false
            }
        case SET_COMPANIES_LOADING:
            return{
                ...state,
                loadingCompanies:true
            }
        case GET_COMPANIES_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorComapnies:action.payload
            }
        case CLEAR_STATE_COMAPANIES:
            return{
                ...state,
                companies:null
            }
        case REGISTER_COMPANY_SUCCESS:
            return {
                ...state,
                loadingRegister: false,
                errorRegister: null
            }
        case REGISTER_COMPANY_FAIL:
            return {
                ...state,
                loadingRegister: false,
                errorRegister: action.payload
            }
        case REGISTER_COMPANY_SET_LOADING:
            return{
                ...state,
                loadingRegister: true
            }
        case GET__MY_COMPANY:
            return{
                ...state,
                myCompany: action.payload,
                loadingMy:false
            }
        case SET_MY_COMPANY_LOADING:
            return{
                ...state,
                loadingMy:true
            }
        case GET_MY_COMPANY_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorMy:action.payload,
                loadingMy:false
            }
        case CLEAR_STATE_MY_COMAPANY:
            return{
                ...state,

                myCompany:null,
                loadingMy:true

            }
        case EDIT_COMPANY_SUCCESS:
            return {
                ...state,
                myCompany:action.payload,
                loadingEdit: false,
                editError: null
            }
        case EDIT_COMPANY_FAIL:
            return {
                ...state,
                loadingEdit: false,
                editError: action.payload
            }
        case CLEAR_EDIT_ERRORS:
            return {
                ...state,
                loadingEdit: false,
                editError: null
            }
        case SET_EDIT_LOADING:
            return {
                ...state,
                loadingEdit: true,
            }
        ///reqest to join
        case POST_REQUEST_COMPANY:
            return {
                ...state,
                loadingRequest: false,
                errorRequest: null,
                reqestResponse:action.payload
            }
        case REQUEST_COMPANY_FAIL:
            return {
                ...state,
                loadingRequest: false,
                errorRequest: action.payload
            }
        case LOADING_REQUEST_COMPANY:
            return{
                ...state,
                loadingRequest: true
            }
            //get all requests
        case GET_ALL_REQUESTS:
            return{
                ...state,
                allRequests: action.payload,
                loadingAllRequests:false
            }
        case SET_ALL_REQUESTS_LOADING:
            return{
                ...state,
                loadingAllRequests:true
            }
        case GET_ALL_REQUESTS_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorAllRequests:action.payload,
                allRequests:null
            }
        case CLEAR_STATE_ALL_REQUESTS:
            return{
                ...state,
                allRequests:null
            }
        ///cancel join request
        case POST_CANACEL_REQUEST:
            return {
                ...state,
                loadingCancel: false,
                errorCancel: null,
                cancelResponse:action.payload
            }
        case CANACEL_REQUEST_FAIL:
            return {
                ...state,
                loadingCancel: false,
                errorCancel: action.payload
            }
        case LOADING_CANACEL_REQUEST:
            return{
                ...state,
                loadingCancel: true
            }
        //get company admin request
        case GET_COMPANY_REQUESTS:
            return{
                ...state,
                companyRequests: action.payload,
                loadingCompanyRequests:false,
                errorCompanyRequests:null
            }
        case SET_COMPANY_REQUESTS_LOADING:
            return{
                ...state,
                loadingCompanyRequests:true
            }
        case GET_COMPANY_REQUESTS_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorCompanyRequests:action.payload,
                companyRequests:null
            }
        case CLEAR_STATE_COMPANY_REQUESTS:
            return{
                ...state,
                companyRequests:null
            }
        //accept reqest
        // case POST_ACCEPT_REQUEST:
        //     return {
        //         ...state,
        //         loadingAccept: false,
        //         errorAccept: null,
        //         acceptResponse:action.payload,
        //         // companyRequests: companyRequests.f
        //     }
        // case POST_ACCEPT_FAIL:
        //     return {
        //         ...state,
        //         loadingAccept: false,
        //         errorAccept: action.payload
        //     }
        // case LOADING_ACCEPT_REQUEST:
        //     return{
        //         ...state,
        //         loadingAccept: true
        //     }
        case POST_ACCEPT_REQUEST:
            var temp1 =state.companyRequests
            let index1= temp1.findIndex((element)=>{return element.id === action.payload.id})
            temp1[index1] = action.payload
            return {
                ...state,
                loadingAccept: false,
                loadingCompanyRequests:false,
                errorAccept: null,
                acceptResponse:action.payload,
                companyRequests: temp1
            }
        case POST_ACCEPT_FAIL:
            return {
                ...state,
                loadingAccept: false,
                errorAccept: action.payload,
                loadingCompanyRequests:false,

            }
        case LOADING_ACCEPT_REQUEST:
            return{
                ...state,
                loadingAccept: true,
                loadingCompanyRequests: true
            }
        ///reject by admin
        case POST_REJECT_REQUEST:
            var temp =state.companyRequests
            let index= temp.findIndex((element)=>{return element.id === action.payload.id})
            temp[index] = action.payload
            return {
                ...state,
                loadingReject: false,
                loadingCompanyRequests:false,
                errorReject: null,
                rejectResponse:action.payload,
                companyRequests: temp
            }
        case REJECT_REQUEST_FAIL:
            return {
                ...state,
                loadingReject: false,
                loadingCompanyRequests:false,
                errorReject: action.payload
            }
        case LOADING_REJECT_REQUEST:
            return{
                ...state,
                loadingReject: true,
                loadingCompanyRequests: true
            }
        default:
            return state
        }
}